const ENV = {
    DEBUG: true,
    APP_ENV: 'local',
    DELAY_INIT: 3000,
}
export default ENV;


// WEBPACK FOOTER //
// ./scripts/env.js